import { Injectable, inject } from "@angular/core";

import { FHIRMiddlewareApiService } from "@fhir-api";

import { Observable, map, of, tap } from "rxjs";
import { AppStateService } from "./app-state.service";

@Injectable({ providedIn: "root" })
export class AppImageManagerService {
    private _appStateService = inject(AppStateService);
    private _fhirMiddlewareApiService = inject(FHIRMiddlewareApiService);

    getImageUrl$(imageName: string): Observable<string | null> {
        const organization = this._appStateService.selectedOrganization();
        const projectName = this._appStateService.selectedRegistryName();
        if (!organization || !projectName) {
            return of(null);
        }
        return this._fhirMiddlewareApiService
            .getImageData$(organization, projectName, imageName)
            .pipe(
                map(response => {
                    return response.headers.get("content-type")
                        ? `data:${response.headers.get("content-type")};base64,${response.body}`
                        : `data:image/png;base64,${response.body}`;
                })
            );
    }
}
